import { render, staticRenderFns } from "./BulletinIndexComponent.vue?vue&type=template&id=4bd8cc3f&scoped=true&"
import script from "./BulletinIndexComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinIndexComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinIndexComponent.vue?vue&type=style&index=0&id=4bd8cc3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8cc3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd8cc3f')) {
      api.createRecord('4bd8cc3f', component.options)
    } else {
      api.reload('4bd8cc3f', component.options)
    }
    module.hot.accept("./BulletinIndexComponent.vue?vue&type=template&id=4bd8cc3f&scoped=true&", function () {
      api.rerender('4bd8cc3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinIndexComponent.vue"
export default component.exports